export function mapApiRowsToItems(paginatorOrContacts) {
  const data = paginatorOrContacts?.data
  if (!Array.isArray(data)) return []
  return data.map(row => ({
    contactId: row.contactId ?? row.contact_id ?? null,
    contactZohoId: row.contactZohoId ?? row.contact_zoho_id ?? null,

    email: row.email ?? null,
    firstname: row.firstname ?? null,
    lastname: row.lastname ?? null,
    country: row.country ?? null,

    hasContract: Boolean(row.hasContract ?? row.has_contract),

    contractId: row.contractId ?? row.contract_id ?? null,
    contractZohoId: row.contractZohoId ?? row.contract_zoho_id ?? null,
    contractType: row.contractType ?? row.contract_type ?? null,
    prestationType: row.prestationType ?? row.prestation_type ?? null,
    status: row.status ?? null,
    contractCreatedAt: row.contractCreatedAt ?? row.contract_created_at ?? null,
    contractUpdatedAt: row.contractUpdatedAt ?? row.contract_updated_at ?? null,
    providerName: row.providerName ?? row.provider_name ?? null,
    providerExternalId: row.providerExternalId ?? row.provider_external_id ?? null,
  }))
}
